export default {
    loading(state) {
        return state.loading;
    }
}
